import React, { createContext, useState } from 'react';
import { translations } from "../translations";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState("sv"); // Default to Swedish

  const getTranslation = key => {
    return translations[currentLanguage][key] || key;
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage,
        setCurrentLanguage,
        t: getTranslation
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
